import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant SEO - Gère les meta tags dynamiques pour chaque page
 * Améliore le référencement avec des meta tags optimisés
 */
function SEO({ title, description, keywords, image, type = 'website' }) {
  const location = useLocation();
  
  // URL de base
  const baseUrl = 'https://wotes.org';
  const currentUrl = `${baseUrl}${location.pathname}`;
  const defaultImage = `${baseUrl}/logo.png`;

  useEffect(() => {
    // Mise à jour du titre
    document.title = title || 'Wote - Au delà de l\'imagination!';

    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || 'Wote - Votre partenaire pour la réussite académique et l\'excellence technologique. Services de consultant informatique, solutions IT, orientation académique, projets de fin d\'études et accompagnement de projets.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description || 'Wote - Votre partenaire pour la réussite académique et l\'excellence technologique.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    const keywordsContent = keywords || 'Wote, consultant informatique, solutions IT, orientation académique, projets fin d\'études, TFE, TFC, TP, développement web, applications mobiles, Kinshasa, RDC, startup technologique';
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywordsContent);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = keywordsContent;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }

    // Open Graph
    updateMetaTag('property', 'og:title', title || 'Wote - Au delà de l\'imagination!');
    updateMetaTag('property', 'og:description', description || 'Wote - Votre partenaire pour la réussite académique et l\'excellence technologique.');
    updateMetaTag('property', 'og:image', image || defaultImage);
    updateMetaTag('property', 'og:url', currentUrl);
    updateMetaTag('property', 'og:type', type);
    updateMetaTag('property', 'og:site_name', 'Wote');

    // Twitter Card
    updateMetaTag('name', 'twitter:card', 'summary_large_image');
    updateMetaTag('name', 'twitter:title', title || 'Wote - Au delà de l\'imagination!');
    updateMetaTag('name', 'twitter:description', description || 'Wote - Votre partenaire pour la réussite académique et l\'excellence technologique.');
    updateMetaTag('name', 'twitter:image', image || defaultImage);

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', currentUrl);
    } else {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = currentUrl;
      document.getElementsByTagName('head')[0].appendChild(canonical);
    }
  }, [title, description, keywords, image, type, currentUrl, defaultImage, location.pathname]);

  // Fonction helper pour mettre à jour ou créer les meta tags
  const updateMetaTag = (attribute, value, content) => {
    let meta = document.querySelector(`meta[${attribute}="${value}"]`);
    if (meta) {
      meta.setAttribute('content', content);
    } else {
      meta = document.createElement('meta');
      meta.setAttribute(attribute, value);
      meta.setAttribute('content', content);
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  };

  return null; // Ce composant ne rend rien visuellement
}

export default SEO;

